module.exports = __webpack_public_path__ + "static/media/known-badge.7255062f.png";